export interface HeadMenuRow {
  key: string;
  name: string;
  url: string;
  msg: string;
  isShow: boolean;
}
export interface SubMenuRow {
  key: string;
  name: string;
  url: string;
  msg: string;
  hmenu:string;
  isShow: boolean;
}

export const hmenu:HeadMenuRow[]=[
  {key:"main",name:"테스트메인",url:"/test",msg:"",isShow:true},
  {key:"design",name:"디자인",url:"/test/design",msg:"",isShow:true},
  {key:"db",name:"데이터",url:"/test/db/excute/main",msg:"",isShow:true},
  {key:"util",name:"유틸",url:"/test/util/url_str",msg:"",isShow:true},
  {key:"trade",name:"정산",url:"/test/trade/nice_pay",msg:"",isShow:true},
];
export const smenu:SubMenuRow[]=[
  {key:"test_main",name:"메인",url:"/test",msg:"",hmenu:"main",isShow:false},
  
  {key:"design_main",name:"디자인메인",url:"/test/design",msg:"",hmenu:"design",isShow:false},
  {key:"design_list",name:"리스트",url:"/test/design/list",msg:"",hmenu:"design",isShow:true},
  {key:"design_btn",name:"버튼",url:"/test/design/btn",msg:"",hmenu:"design",isShow:true},
  {key:"design_content",name:"내용",url:"/test/design/content",msg:"",hmenu:"design",isShow:true},
  {key:"design_table",name:"테이블",url:"/test/design/table",msg:"",hmenu:"design",isShow:true},
  {key:"design_popup",name:"팝업",url:"/test/design/popup",msg:"",hmenu:"design",isShow:true},
  {key:"design_chat",name:"채팅",url:"/test/design/chat",msg:"",hmenu:"design",isShow:true},
  {key:"design_youtube",name:"유튜브",url:"/test/design/video/youtube",msg:"",hmenu:"design",isShow:true},
  {key:"design_layout_stu",name:"레이아웃1",url:"/test/design/layout/student",msg:"",hmenu:"design",isShow:true},

  {key:"db_excute_main",name:"실행",url:"/test/db/excute/main",msg:"",hmenu:"db",isShow:true},
  {key:"db_excute_list",name:"리스트",url:"/test/db/excute/list_page",msg:"",hmenu:"db",isShow:true},
  {key:"db_counsel_todo",name:"상담",url:"/test/db/counsel_todo",msg:"",hmenu:"db",isShow:true},
  {key:"clova_chat",name:"출석테스트",url:"/test/db/attend/test",msg:"",hmenu:"db",isShow:true},
  {key:"clova_chat",name:"클로바x챗",url:"/test/db/clova/chat",msg:"",hmenu:"db",isShow:true},

  {key:"url_str_page",name:"URL얻기",url:"/test/util/url_str",msg:"",hmenu:"util",isShow:true},
  {key:"push_main",name:"푸시",url:"/test/util/push",msg:"",hmenu:"util",isShow:true},
  {key:"sche_main",name:"스케줄",url:"/test/util/schedule",msg:"",hmenu:"util",isShow:true},
  {key:"excel_down",name:"엑셀다운",url:"/test/util/excel/down",msg:"",hmenu:"util",isShow:true},
  {key:"excel_upload",name:"엑셀업로드",url:"/test/util/excel/upload",msg:"",hmenu:"util",isShow:true},
  {key:"kakao_send_notice",name:"알림톡",url:"/test/util/kakao/send_notice",msg:"",hmenu:"util",isShow:true},
  {key:"util_comp_main",name:"업체유틸",url:"/test/util/comp/main",msg:"",hmenu:"util",isShow:true},
  {key:"coolen_main",name:"쿨잉",url:"/test/util/coolen/main",msg:"",hmenu:"util",isShow:true},
  {key:"open_ai_chat",name:"OpenAI",url:"/test/util/ai/open_ai",msg:"",hmenu:"util",isShow:true},

  {key:"nice_pay_test",name:"나이스페이",url:"/test/trade/nice_pay",msg:"",hmenu:"trade",isShow:true},
];